import { AxiosResponse } from 'axios'

import type { ApiClient } from 'clients/yogi-api'
const SOURCE_UPLOAD_PATH_URL = '/source/upload-path'

export class SourceFormService {
  constructor(private client: ApiClient) {}

  /**
   * Fetches the upload path for the file sources
   * @returns {Promise<UploadSourcePathResponse>} Bucket and key for source uploading
   */
  getUploadPath(): Promise<AxiosResponse<unknown>> {
    return this.client.get(SOURCE_UPLOAD_PATH_URL)
  }
}
